import React from 'react';
import { Box } from '@chakra-ui/react';

import { ItemsSummaryAccordion } from '../../../../../../../common/components/ItemsSummaryModal/ItemsSummaryAccordion';
import { useTranslations } from '../../../../../../../contexts/LocalizationContext';
import { useScannedRelevosContext } from '../../../../../../../contexts/ScannedRelevosContext';
import { useDepositResultContext } from '../../../../../context/DepositResultContext/DepositResultContext';
import { DepositRelevoTableMode } from '../../../../../model/enums/deposit-relevo-table-mode.enum';
import { DepositRelevoTable } from '../../../DepositRelevoTable/DepositRelevoTable';

export const DepositFailureResult = () => {
  const translations = useTranslations();
  const { mode } = useScannedRelevosContext();
  const { failureItems } = useDepositResultContext();

  return (
    <Box px={8} pt={4}>
      <ItemsSummaryAccordion isOpen={true} buttonText={translations('errors')}>
        <DepositRelevoTable items={failureItems} tableMode={DepositRelevoTableMode.ERROR} scannerMode={mode} />
      </ItemsSummaryAccordion>
    </Box>
  );
};
